import { APIAuthClient, APIClient } from 'service/apicataleg/api/APIHttpClient';
import { OrderDTO, OrdersQueryResponse } from 'service/apicataleg/types/ApiCatalegTypes';

export type GetClientOrdersRequest = {
  client: number;
  year: number;
  month: number;
  npes?: string;
};

export type TokenGestOrder = {
  token: string;
};

const OrderRepreService = {
  async getClientOrders({
    client,
    year,
    month,
    npes = '',
  }: GetClientOrdersRequest): Promise<OrdersQueryResponse | null> {
    try {
      const { data } = await APIAuthClient.get<OrdersQueryResponse>(
        `/representant/orders/client/${client}?year=${year}&month=${month}&npes=${npes}`,
      );
      return data;
    } catch (error) {
      return null;
    }
  },

  async getOrder(npe: number): Promise<OrderDTO | null> {
    try {
      const { data } = await APIAuthClient.get(`/representant/orders/${npe}`);
      return data;
    } catch (error) {
      return null;
    }
  },

  async getOrderGuest(token: string): Promise<OrderDTO | null> {
    try {
      const { data } = await APIClient.get(`/guest/order?token=${token}`);
      return data;
    } catch (error) {
      return null;
    }
  },

  async getTokenOrderGuest(npe: number): Promise<string> {
    try {
      const { data } = await APIAuthClient.get<TokenGestOrder>(
        `/representant/orders/${npe}/tokenguest`,
      );
      return data.token;
    } catch (error) {
      return '';
    }
  },

  async getOrderFile(npe: number): Promise<Blob> {
    const response = await APIAuthClient.get<Blob>(`/representant/orders/${npe}/download`, {
      responseType: 'blob',
    });
    const { data } = response;
    return data;
  },
};

export default OrderRepreService;
